import { useState } from "react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import Portal from "../Portal";

export const LifetimeAiModal = ({ doctor, onClose, onDone }) => {
  const [amount, setAmount] = useState("19.99");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const active = doctor.ai_courtesy;

  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/users/${doctor.id}/ai-courtesy`, active ? { enabled: false } : {
        enabled: true, amount: amount === "" ? null : parseFloat(amount), note,
      });
      toast.success(active ? "IA de por vida desactivada" : `IA de por vida activada para ${doctor.name}`);
      onDone();
      onClose();
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Portal>
      <div className="fixed inset-0 z-[80] bg-black/30 backdrop-blur-sm grid place-items-center p-4" onClick={onClose}>
        <div
          className="cai-panel relative overflow-hidden w-full max-w-[400px] rounded-[28px] p-6 text-white"
          onClick={(e) => e.stopPropagation()}
          data-testid="lifetime-ai-modal"
        >
          <div className="relative z-10 space-y-4">
            <div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-white/80">ConsuDoctor AI</div>
              <div className="text-[18px] font-semibold mt-1">{active ? "Quitar IA de por vida" : "Activar IA de por vida"}</div>
              <div className="text-[12.5px] text-white/85 mt-1">{doctor.name} · {doctor.email}</div>
            </div>
            {active ? (
              <p className="text-[13px] text-white/90">
                El doctor perderá el acceso a la IA, salvo que tenga una suscripción pagada activa.
              </p>
            ) : (
              <>
                <p className="text-[12.5px] text-white/90">El doctor tendrá la IA activa para siempre y no se le cobrará nada en la app.</p>
                <label className="block">
                  <span className="block text-[10px] uppercase tracking-[0.16em] text-white/75 mb-1">Monto cobrado por fuera (US$)</span>
                  <input
                    type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)}
                    data-testid="lifetime-amount"
                    className="w-full h-10 px-3 rounded-xl bg-white/15 border border-white/30 text-[14px] text-white outline-none"
                  />
                </label>
                <label className="block">
                  <span className="block text-[10px] uppercase tracking-[0.16em] text-white/75 mb-1">Nota (opcional)</span>
                  <input
                    value={note} onChange={(e) => setNote(e.target.value)} placeholder="Ej: pagó por transferencia"
                    data-testid="lifetime-note"
                    className="w-full h-10 px-3 rounded-xl bg-white/15 border border-white/30 text-[14px] text-white placeholder:text-white/60 outline-none"
                  />
                </label>
              </>
            )}
            <div className="flex gap-2 pt-1">
              <button
                type="button" onClick={save} disabled={busy} data-testid="lifetime-confirm"
                className="h-10 px-5 rounded-full bg-white text-[#5B8FD0] text-[13px] font-semibold hover:bg-white/90 transition-colors disabled:opacity-50"
              >
                {busy ? "Guardando…" : active ? "Quitar" : "Activar de por vida"}
              </button>
              <button
                type="button" onClick={onClose} data-testid="lifetime-cancel"
                className="h-10 px-5 rounded-full bg-[#2B4A6F]/25 border border-white/35 text-[13px] font-semibold"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};
